interface GetHasAvailableDatesOnCurrentMonthConfig {
  currentDate?: Date;
  availableDates: Date[];
}

export function hasAvailableDateOnCurrentMonth({
  currentDate = new Date(),
  availableDates,
}: GetHasAvailableDatesOnCurrentMonthConfig) {
  return availableDates?.some((availableDate) => {
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    return (
      availableDate.getMonth() === currentMonth &&
      availableDate.getFullYear() === currentYear
    );
  });
}
